module.exports = __webpack_public_path__ + "img/wave-1-yellow-400.fb2ea0d.png";